'use es6';

import { bender } from 'legacy-hubspot-bender-context'; // import-eslint-disable-line

export var getIconUrl = function getIconUrl(set, iconName) {
  var style = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'default';
  return bender.staticDomainPrefix + "/content-icons-ui/" + bender.depVersions['content-icons-ui'] + "/images/" + set + "/" + encodeURIComponent(iconName) + "/" + style + ".svg";
};